module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eGJcU"))).then(() => module.bundle.root('fThBo'));